/* eslint-disable eag/match-named-export */
import {ThemeZIndexPath} from '../types/ThemePaths';

/**
 * Z-index values for inline styles
 * Using inline styles because z-index values don't have corresponding Tailwind classes
 */
export const ZINDEX_VALUES: Record<ThemeZIndexPath, number | 'auto'> = {
  hide: -1,
  auto: 'auto',
  base: 0,
  sidebar: 9,
  'big-calendar-current-time-indicator': 10,
  'big-calendar-sticky-allday-slot': 11,
  'big-calendar-resource-title': 12,
  'big-calendar-resource-title-header': 13,
  'big-calendar-header': 14,
  'big-calendar-dialog': 15,
  content: 100,
  'content-loader': 120,
  'page-navigation': 200,
  header: 300,
  'header-popper': 301,
  'main-menu': 302,
  'swiper-button': 400,
  modal: 500,
  'modal-component': 1000,
  'fullscreen-modal': 1400,
  'dropdown-component': 1450,
  'choice-menu': 9000,
  'rotate-overlay': 9001,
  tooltip: 90050,
  overlay: 9100,
  'lightbox-overlay': 90001,
  'lightbox-actions': 90002,
  'lightbox-detail': 90003,
  'lightbox-detail-actions': 90004,
  'lightbox-modal': 90005,
  'toast-notification': 90010,
};
